import React, { Component } from "react";
import PropTypes from "prop-types";
import i18n from "i18n-react";

import {
  FillBlanks,
  FlipBoard,
  MultipleChoice,
  MultipleDropdown,
  SwitchButton,
  TrainingDials,
  TrainingImage,
  TrainingSlider,
  TrainingText,
  TrainingVideo,
  ArrangeTheWords,
  MatchTheSentence,
} from "C4";

const LinkButtons = (props) => {
  document.addEventListener("scroll", () => {
    const buttons = document.querySelector(".trainingContent__linkButtons");
    const text = document.querySelector(".text__container");
    const bodyContent = document.querySelector(".bodyContent");

    if (
      buttons !== null &&
      window.scrollY - (buttons.clientHeight + 140) >= text.offsetTop
    ) {
      buttons.style.top = `${window.scrollY - text.offsetTop}px`;
    } else if (buttons !== null) {
      buttons.style.top = `${bodyContent.offsetTop + 72}px`;
    }
  });

  return <div className="trainingContent__linkButtons">{props.buttons}</div>;
};

class TrainingContent extends Component {
  selectQuestion() {
    const {
      contentComplete,
      error,
      LinkButtons: buttons,
      type: contentType,
    } = this.props;
    const { type, layout } = this.props.params;
    const { params } = this.props;

    params.buttons = <LinkButtons buttons={buttons} />;
    params.contentComplete = contentComplete;
    params.error = error;
    if (contentType === "fasttrack") params.disableToast = true;

    if (this.props.params.length === 0) {
      contentComplete();
    }

    switch (type) {
      case "stepsValues":
      case "stepsNormal":
        return {
          slider: <TrainingSlider {...params} />,
          s: <TrainingSlider {...params} />,
          f: <FlipBoard {...params} />,
        }[layout];

      case "QuestionMultipleChoice":
        return {
          mCD: <MultipleDropdown key={`mCD_${params.UPID}`} {...params} />,
          mC: <MultipleChoice key={`mC_${params.UPID}`} {...params} />,
          mMC: <MultipleChoice key={`mMC_${params.UPID}`} {...params} />,
        }[layout];

      case "QuestionMultipleChoiceImage":
        return {
          mCI: <MultipleChoice key={`mC_${params.UPID}`} {...params} />,
        }[layout];

      case "QuestionComboLock":
        return {
          dial: <TrainingDials {...params} />,
          d: <TrainingDials {...params} />,
        }[layout];

      case "QuestionOther":
        return <MultipleChoice {...params} />;

      case "QuestionFillInTheBlank":
        return {
          fITB: (
            <FillBlanks {...params} title={i18n.translate("questions.fitb")} />
          ),
        }[layout];

      case "QuestionArrangeTheWords":
        return <ArrangeTheWords {...params} />;

      case "QuestionMatchTheSentence":
        return <MatchTheSentence {...params} />;

      case "QuestionTrueFalse":
        return <SwitchButton {...params} />;

      default:
        return "";
    }
  }

  selectContent() {
    const { contentComplete, appId, LinkButtons: buttons } = this.props;
    const { image, pageType, type, answer } = this.props.params;
    const { params } = this.props;

    params.buttons = <LinkButtons buttons={buttons} />;
    params.contentComplete = contentComplete;
    params.appId = appId;
    if (answer) {
      params.answer = answer.filter((a) => a !== null && a.length > 0);
    }

    const links = [];
    for (let i = 1; i < 6; i += 1) {
      links.push({ url: params[`link${i}`], type: params[`linkType${i}`] });
    }

    const linksJW = [];
    for (let i = 1; i < 6; i += 1) {
      linksJW.push({ url: params[`linkJW${i}`], type: params[`linkJW${i}`] });
    }

    switch (pageType) {
      case "Video":
      case "autoPlay":
        return <TrainingVideo {...params} />;

      case "Spotify":
      case "":
      case "Final-Page":
        return (
          <div>
            {image && <TrainingImage {...params} />}
            <TrainingText {...params} />
          </div>
        );

      case "Introduction":
        return (
          <React.Fragment>
            <TrainingImage {...params} type={pageType} />
            <TrainingText {...params} />
          </React.Fragment>
        );

      case "Photo":
        return (
          <div>{image && <TrainingImage {...params} type={pageType} />}</div>
        );

      case "Webview":
        break;

      default:
        if (type !== undefined) {
          return this.selectQuestion();
        }
    }
    return "";
  }

  render() {
    return <div>{this.selectContent()}</div>;
  }
}

export default TrainingContent;

export { default as LinkButton } from "./LinkButton";
export { default as MultipleChoice } from "./MultipleChoice";
export { default as NavigationButton } from "./NavigationButton";
export { default as TrainingDials } from "./TrainingDials";
export { default as TrainingImage } from "./TrainingImage";
export { default as TrainingSlider } from "./TrainingSlider";
export { default as TrainingText } from "./TrainingText";
export { default as TrainingVideo } from "./TrainingVideo";

TrainingContent.propTypes = {
  appId: PropTypes.number.isRequired,
  contentComplete: PropTypes.func.isRequired,
  error: PropTypes.func,
  LinkButtons: PropTypes.arrayOf(PropTypes.element),
  params: PropTypes.shape(),
};

TrainingContent.defaultProps = {
  error: () => {},
  LinkButtons: [],
  params: {},
};

LinkButtons.propTypes = {
  buttons: PropTypes.arrayOf(PropTypes.shape()),
};

LinkButtons.defaultProps = {
  buttons: [],
};
